import { c as _c } from "react/compiler-runtime";
import React from "react";
import { CourseCardSkeleton } from "./course-card-skeleton";
export const StartLearningWithSpoclearnLoader = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <CourseCardSkeleton />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="hidden sm:block"><CourseCardSkeleton /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="grid gap-5 p-1 sm:grid-cols-3">{t0}{t1}<div className="hidden sm:block"><CourseCardSkeleton /></div><span className="sr-only">Loading...</span></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};